import React from 'react';
import { Route } from 'react-router';
import EventsPdfPageRoute from './EventsPdfPageRoute';

const basePath = '/v2/events/pdf';

export default <Route path={basePath} element={<EventsPdfPageRoute />} />;
